import { Task } from "../../Pages/Tasks_new/types";
import styles from "./TaskModalButtons.module.css";

interface CheckSubscriptionButtonProps {
  onClick: () => void;
  isLocked: boolean;
  completed?: boolean;
  task: Task;
}
interface HideTaskButtonProps {
  onClick: () => void;
  task: Task;
}

interface SubscribeButtonProps {
  onClick: () => void;
  isLocked: boolean;
  task: Task;
}

const buttonTextsByProvider = {
  subscription: ["BARZHA", "PARTNERS"],
  task: ["TAPPADS", "DAILY"],
};

const getCheckButtonText = (provider?: string) => {
  if (!provider) return "Проверить подписку";

  if (buttonTextsByProvider.task.includes(provider)) {
    return "Проверить задание";
  }

  return "Проверить подписку";
};

const getSubscribeButtonText = (provider?: string) => {
  if (!provider) return "Подписаться";

  if (buttonTextsByProvider.task.includes(provider)) {
    return "Выполнить задание";
  }

  return "Подписаться";
};

export const CheckSubscriptionButton: React.FC<
  CheckSubscriptionButtonProps
> = ({ onClick, isLocked, completed = false, task }) => (
  <button
    className={`${styles.checkSubscriptionButton} ${
      completed ? styles.completed : ""
    }`}
    onClick={onClick}
    disabled={isLocked}
    type="button"
  >
    {getCheckButtonText(task.provider)}
  </button>
);

export const SubscribeButton: React.FC<SubscribeButtonProps> = ({
  onClick,
  isLocked,
  task,
}) => (
  <button
    className={styles.subscribeButton}
    onClick={onClick}
    disabled={isLocked}
    type="button"
  >
    {getSubscribeButtonText(task.provider)}
  </button>
);

export const HideTaskButton: React.FC<HideTaskButtonProps> = ({
  onClick,
  task,
}) => (
  <button className={styles.hideTaskButton} onClick={onClick} type="button">
    Скрыть задание
  </button>
);
